import { WorksheetSchemaProperty } from '../../../../types/custom-worksheet-v2';
import { isField, isList, isSection, isSectionGroup, isTable } from '../store/utils';
import StandaloneField from './field/StandaloneField';
import List from './list/List';
import SectionGroup from './section-group/SectionGroup';
import Section from './section/Section';
import Table from './table/Table';

type PropertyProps = {
    value: WorksheetSchemaProperty;
    allowRedirect?: boolean;
};

function Property({ value, allowRedirect }: PropertyProps): JSX.Element {
    if (isList(value)) {
        return <List list={value} />;
    } else if (isSection(value)) {
        return <Section section={value} allowRedirect={allowRedirect} />;
    } else if (isField(value)) {
        return <StandaloneField field={value} allowRedirect={allowRedirect} />;
    } else if (isTable(value)) {
        return <Table table={value} />;
    } else if (isSectionGroup(value)) {
        return <SectionGroup sectionGroup={value} />;
    }
    return <></>;
}

export default Property;
